import VdsCalculator from "../classes/vds-calculator";

$.when($('#custom_server_params').data()).then(function (config) {
    if (typeof config !== "undefined") {
        new VdsCalculator(config, function () {
            $('.server-conf__loader').fadeOut(200);
        });
    }
});
